export const styles = () => `.control-object-representative-modal-host .app-modal {
  width: 516px;
}`;
